var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page clearfix mt20"},[_c('div',{staticClass:"fl"},[_vm._t("default")],2),_vm._v(" "),_c('div',{staticClass:"fr"},[_c('Page',{attrs:{"total":_vm.num,"show-sizer":""},on:{"on-change":_vm.change_page,"on-page-size-change":_vm.change_opts}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-09d4dd74","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/page/page.vue
// module id = null
// module chunks = 